module.exports = __webpack_public_path__ + "img/img_zh1.aed9335b.jpg";